export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://eecf-paris.fr'